<script setup>
import {ElCard, ElIcon} from "element-plus";
import {WarningFilled} from "@element-plus/icons-vue";
import {activityApi} from "@/service/index.js";
import {useStore} from "vuex";
import {ref} from "vue";

const store = useStore()
let info = ref({})
activityApi().then(res => {
  if (res.data.code == 1) {
    console.log(res)
    info.value = res.data.data
  }
})
</script>
<style  lang="less" scoped>
.h-box {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;

  .xxic {
    width: 30px;
    margin-right: 5px;
  }
}

.detail {
  display: flex;
  margin: 0;
  padding: 0;
}

.prompt {
  background: rgb(255, 229, 0);
  border-radius: 10px;
  box-sizing: border-box;
  padding: 10px;
  margin-top: 20px;

  .tit {
    display: flex;
    align-content: center;
    color: red;
    font-weight: bold;
    margin: 0;
    margin: 5px 0;

    span {
      margin-left: 4px;
      display: flex;
      align-items: center;
    }
  }

  .p-detail {
    line-height: 25px;
  }
}

.sales-promotion {
  background: rgb(45, 194, 107);
  color: white;

  .tit {
    color: yellow;
  }
}
</style>